<template>
  <div style="position: relative;">
    <el-form ref="PaPayrollFilter" :model="PaPayroll" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="类型" prop="formFilter.type">
          <el-select class="filter-item" v-model="PaPayroll.formFilter.type" :clearable="true" filterable
            placeholder="类型" :loading="PaPayroll.type.impl.loading"
            @visible-change="PaPayroll.type.impl.onVisibleChange"
            @change="onTypeValueChange">
            <el-option v-for="item in PaPayroll.type.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="formFilter.name">
          <el-input class="filter-item" v-model="PaPayroll.formFilter.name"
            :clearable="true" placeholder="名称"
          />
        </el-form-item>
        <el-form-item label="状态" prop="formFilter.status">
          <el-select class="filter-item" v-model="PaPayroll.formFilter.status" :clearable="true" filterable
            placeholder="状态" :loading="PaPayroll.status.impl.loading"
            @visible-change="PaPayroll.status.impl.onVisibleChange"
            @change="onStatusValueChange">
            <el-option v-for="item in PaPayroll.status.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="年度" prop="formFilter.paYear">
          <el-date-picker class="filter-item" v-model="PaPayroll.formFilter.paYear" :clearable="true"
                          format="yyyy" value-format="yyyy" type="year" align="left" placeholder="年度"
          />
        </el-form-item>
        <el-form-item label="月份" prop="formFilter.paMonth">
          <el-date-picker class="filter-item" v-model="PaPayroll.formFilter.paMonth" :clearable="true"
                          format="yyyyMM" value-format="yyyyMM" type="month" align="left" placeholder="月份"
          />
        </el-form-item>
        <el-form-item label="季度" prop="formFilter.paQuarter">
          <el-select class="filter-item" v-model="PaPayroll.formFilter.paQuarter" :clearable="true" filterable
            placeholder="季度" :loading="PaPayroll.paQuarter.impl.loading"
            @visible-change="PaPayroll.paQuarter.impl.onVisibleChange"
            @change="onPaQuarterValueChange">
            <el-option v-for="item in PaPayroll.paQuarter.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="formFilter.paDay">
          <el-date-picker class="filter-item" v-model="PaPayroll.formFilter.paDay" :clearable="true"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd 00:00:00"
            type="date" align="left"
            placeholder="日期"
          />
        </el-form-item>
        <el-form-item label="开启绩效" prop="formFilter.paFlag">
          <el-select class="filter-item" v-model="PaPayroll.formFilter.paFlag" :clearable="true" filterable
            placeholder="开启绩效" :loading="PaPayroll.paFlag.impl.loading"
            @visible-change="PaPayroll.paFlag.impl.onVisibleChange"
            @change="onPaFlagValueChange">
            <el-option v-for="item in PaPayroll.paFlag.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="绩效总金额" prop="formFilter.paTotalAmount">
          <input-number-range class="filter-item"
            v-model="PaPayroll.formFilter.paTotalAmount" :clearable="true"
            startPlaceholder="最小值" endPlaceholder="最大值"
          />
        </el-form-item>
        <el-form-item label="总人数" prop="formFilter.totalUserNum">
          <input-number-range class="filter-item"
            v-model="PaPayroll.formFilter.totalUserNum" :clearable="true"
            startPlaceholder="最小值" endPlaceholder="最大值"
          />
        </el-form-item>
        <el-form-item label="总发放金额" prop="formFilter.totalPayrollAmount">
          <input-number-range class="filter-item"
            v-model="PaPayroll.formFilter.totalPayrollAmount" :clearable="true"
            startPlaceholder="最小值" endPlaceholder="最大值"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetPaPayroll">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshPaPayroll(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('PaPayroll:PaPayroll:AddPaPayroll')"
          @click="onAddPaPayrollClick()">
          创建
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="paPayroll" :data="PaPayroll.PaPayroll.impl.dataList" :size="defaultFormItemSize" @sort-change="PaPayroll.PaPayroll.impl.onSortChange"
          header-cell-class-name="table-header-gray" height="540px"
          highlight-current-row @current-change="PaPayroll.PaPayroll.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="PaPayroll.PaPayroll.impl.getTableIndex" />
          <el-table-column label="类型" header-align="center" prop="typeDictMap.name">
          </el-table-column>
          <el-table-column label="名称" header-align="center" prop="name" sortable="custom" width="130px" >
          </el-table-column>
          <el-table-column label="状态" header-align="center" prop="statusDictMap.name" sortable="custom">
          </el-table-column>
          <el-table-column label="年度" header-align="center" prop="paYear" sortable="custom">
          </el-table-column>
          <el-table-column label="月份" header-align="center" prop="paMonth" sortable="custom">
          </el-table-column>
          <el-table-column label="季度" header-align="center" prop="paQuarterDictMap.name" sortable="custom">
          </el-table-column>
          <el-table-column label="日期" header-align="center" prop="paDay" sortable="custom" width="100px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.paDay, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="开启绩效" header-align="center" prop="paFlagDictMap.name">
          </el-table-column>
          <el-table-column label="绩效总金额" header-align="center" prop="paTotalAmount" width="100px">
          </el-table-column>
          <el-table-column label="绩效开始时间" header-align="center" prop="paStartTime" width="100px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.paStartTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="绩效截至时间" header-align="center" prop="paEndTime" width="100px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.paEndTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="绩效总分数" header-align="center" prop="paTotalScore">
          </el-table-column>
          <el-table-column label="考评开始时间" header-align="center" prop="assessStartTime" width="100px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.assessStartTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="考评结束时间" header-align="center" prop="assessEndTime" width="100px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.assessEndTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="考评后总分" header-align="center" prop="assessTotalScore">
          </el-table-column>
          <el-table-column label="分值系数" header-align="center" prop="scoreRatio">
          </el-table-column>
          <el-table-column label="总人数" header-align="center" prop="totalUserNum">
          </el-table-column>
          <el-table-column label="总发放金额" header-align="center" prop="totalPayrollAmount">
          </el-table-column>
          <el-table-column label="创建人" header-align="center" prop="createUserIdDictMap.name">
          </el-table-column>
          <el-table-column label="创建时间" header-align="center" prop="createTime" width="100px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="更新人" header-align="center" prop="updateUserIdDictMap.name" width="100px">
          </el-table-column>
          <el-table-column label="更新时间" header-align="center" prop="updateTime" width="100px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.updateTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" header-align="center" width="170px">
            <template slot-scope="scope">
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('PaPayroll:PaPayroll:delete')">
                删除
              </el-button>
              <el-button @click.stop="onEditPaPayrollClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('PaPayroll:PaPayroll:EditPaPayroll')">
                编辑
              </el-button>
              <el-button @click.stop="onUserSalaryRecordClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('PaPayroll:PaPayroll:UserSalaryRecord')">
                查看
              </el-button>
              <el-button @click.stop="onEditPayrollUserSalaryClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('PaPayroll:PaPayroll:EditPayrollUserSalary')">
                操作
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="PaPayroll.PaPayroll.impl.totalCount"
            :current-page="PaPayroll.PaPayroll.impl.currentPage"
            :page-size="PaPayroll.PaPayroll.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="PaPayroll.PaPayroll.impl.onCurrentPageChange"
            @size-change="PaPayroll.PaPayroll.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaPayrollController, DictionaryController } from '@/api';
import editPaPayroll from '@/views/PaPayroll/editPaPayroll.vue';
import addPaPayroll from '@/views/PaPayroll/addPaPayroll.vue';

export default {
  name: 'PaPayroll',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      PaPayroll: {
        formFilter: {
          type: undefined,
          name: undefined,
          status: undefined,
          paYear: undefined,
          paMonth: undefined,
          paQuarter: undefined,
          paDay: undefined,
          paFlag: undefined,
          paTotalAmount: [],
          totalUserNum: [],
          totalPayrollAmount: []
        },
        formFilterCopy: {
          type: undefined,
          name: undefined,
          status: undefined,
          paYear: undefined,
          paMonth: undefined,
          paQuarter: undefined,
          paDay: undefined,
          paFlag: undefined,
          paTotalAmount: [],
          totalUserNum: [],
          totalPayrollAmount: []
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        status: {
          impl: new DropdownWidget(this.loadStatusDropdownList)
        },
        paQuarter: {
          impl: new DropdownWidget(this.loadPaQuarterDropdownList)
        },
        paFlag: {
          impl: new DropdownWidget(this.loadPaFlagDropdownList)
        },
        PaPayroll: {
          impl: new TableWidget(this.loadPaPayrollWidgetData, this.loadPaPayrollVerify, true, true, 'createTime', 0)
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetPaPayroll () {
      this.$refs.PaPayrollFilter.resetFields();
      this.refreshPaPayroll(true);
    },
    /**
     * 工资发放数据获取函数，返回Promise
     */
    loadPaPayrollWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paPayrollDtoFilter: {
          type: this.PaPayroll.formFilterCopy.type,
          name: this.PaPayroll.formFilterCopy.name,
          status: this.PaPayroll.formFilterCopy.status,
          paYear: this.PaPayroll.formFilterCopy.paYear,
          paMonth: this.PaPayroll.formFilterCopy.paMonth,
          paQuarter: this.PaPayroll.formFilterCopy.paQuarter,
          paDay: this.PaPayroll.formFilterCopy.paDay,
          paFlag: this.PaPayroll.formFilterCopy.paFlag,
          paTotalAmountStart: Array.isArray(this.PaPayroll.formFilterCopy.paTotalAmount) ? this.PaPayroll.formFilterCopy.paTotalAmount[0] : undefined,
          paTotalAmountEnd: Array.isArray(this.PaPayroll.formFilterCopy.paTotalAmount) ? this.PaPayroll.formFilterCopy.paTotalAmount[1] : undefined,
          totalUserNumStart: Array.isArray(this.PaPayroll.formFilterCopy.totalUserNum) ? this.PaPayroll.formFilterCopy.totalUserNum[0] : undefined,
          totalUserNumEnd: Array.isArray(this.PaPayroll.formFilterCopy.totalUserNum) ? this.PaPayroll.formFilterCopy.totalUserNum[1] : undefined,
          totalPayrollAmountStart: Array.isArray(this.PaPayroll.formFilterCopy.totalPayrollAmount) ? this.PaPayroll.formFilterCopy.totalPayrollAmount[0] : undefined,
          totalPayrollAmountEnd: Array.isArray(this.PaPayroll.formFilterCopy.totalPayrollAmount) ? this.PaPayroll.formFilterCopy.totalPayrollAmount[1] : undefined
        }
      }
      return new Promise((resolve, reject) => {
        PaPayrollController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.PaPayroll.PaPayroll.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.PaPayroll.PaPayroll.impl.currentRow.id, 'id');
              this.$refs.paPayroll.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 工资发放数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaPayrollVerify () {
      this.PaPayroll.formFilterCopy.type = this.PaPayroll.formFilter.type;
      this.PaPayroll.formFilterCopy.name = this.PaPayroll.formFilter.name;
      this.PaPayroll.formFilterCopy.status = this.PaPayroll.formFilter.status;
      this.PaPayroll.formFilterCopy.paYear = this.PaPayroll.formFilter.paYear;
      this.PaPayroll.formFilterCopy.paMonth = this.PaPayroll.formFilter.paMonth;
      this.PaPayroll.formFilterCopy.paQuarter = this.PaPayroll.formFilter.paQuarter;
      this.PaPayroll.formFilterCopy.paDay = this.PaPayroll.formFilter.paDay;
      this.PaPayroll.formFilterCopy.paFlag = this.PaPayroll.formFilter.paFlag;
      this.PaPayroll.formFilterCopy.paTotalAmount = this.PaPayroll.formFilter.paTotalAmount;
      this.PaPayroll.formFilterCopy.totalUserNum = this.PaPayroll.formFilter.totalUserNum;
      this.PaPayroll.formFilterCopy.totalPayrollAmount = this.PaPayroll.formFilter.totalPayrollAmount;
      return true;
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_payroll_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 状态下拉数据获取函数
     */
    loadStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_payroll_status'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 状态选中值改变
     */
    onStatusValueChange (value) {
    },
    /**
     * 季度下拉数据获取函数
     */
    loadPaQuarterDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_payroll_quarter'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 季度选中值改变
     */
    onPaQuarterValueChange (value) {
    },
    /**
     * 开启绩效下拉数据获取函数
     */
    loadPaFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 开启绩效选中值改变
     */
    onPaFlagValueChange (value) {
    },
    /**
     * 更新工资发放计划
     */
    refreshPaPayroll (reloadData = false) {
      if (reloadData) {
        this.PaPayroll.PaPayroll.impl.refreshTable(true, 1);
      } else {
        this.PaPayroll.PaPayroll.impl.refreshTable();
      }
      if (!this.PaPayroll.isInit) {
        // 初始化下拉数据
      }
      this.PaPayroll.isInit = true;
    },
    /**
     * 创建
     */
    onAddPaPayrollClick () {
      let params = {};

      this.$dialog.show('创建', addPaPayroll, {
        area: '1100px'
      }, params).then(res => {
        this.refreshPaPayroll();
      }).catch(e => {});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaPayrollController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.PaPayroll.PaPayroll.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditPaPayrollClick (row) {
      let params = {
        id: row.id
      };

      this.$dialog.show('编辑', editPaPayroll, {
        area: '1100px'
      }, params).then(res => {
        this.PaPayroll.PaPayroll.impl.refreshTable();
      }).catch(e => {});
    },
    /**
     * 薪资记录
     */
    onUserSalaryRecordClick (row) {
      let params = {
        payrollId: row.id,
        name: row.name
      };

      params.closeVisible = 1;
      this.$router.push({name: 'PayrollUserSalaryRecord', query: params});
    },
    /**
     * 操作
     */
    onEditPayrollUserSalaryClick (row) {
      let params = {
        payrollId: row.id,
        name: row.name
      };

      params.closeVisible = 1;
      this.$router.push({name: 'EditPayrollUserSalary', query: params});
    },
    onResume () {
      this.refreshPaPayroll();
    },
    initFormData () {
    },
    formInit () {
      this.refreshPaPayroll();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
